import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type { BaseFilterValue } from '../types'

export const useSortOptions = (): BaseFilterValue[] => {
  const { t } = useTranslation()

  return useMemo(
    () => [
      { label: t('general.most_relevant'), value: '' },
      { label: t('general.price_low_to_high'), value: 'price-asc' },
      { label: t('general.price_high_to_low'), value: 'price-desc' },
    ],
    [],
  )
}
